module.exports = __webpack_public_path__ + "img/icon_guide@3x.6815e46f.png";